import LimitsContainer from './LimitsContainer.jsx';
import Select from '../Select';
import TextInput from '../TextInput';
import TextInputWithInlineLabel from '../TextInputWithInlineLabel.jsx';
import { useEffect } from 'react';
import InfoMessageBlock from '~/components/InfoMessageBlock';

const descriptionMap = {
    unlimited: 'unlimited upcoming appointments',
    monthly: 'a max number of appointments each month',
    weekly: 'a max number of appointments each week',
    upcoming: 'a max number of upcoming appointments',
};

const LimitDescription = ({ limit }) => {
    if (!limit || limit.type === 'unlimited' || limit.count <= 0) {
        return (
            <div>
                Each client can book as many upcoming appointments as they want
            </div>
        );
    }

    return (
        <div>
            {limit.type === 'monthly' && (
                <div>
                    Each client can book a max of {limit.count} appointment
                    {limit.count > 1 ? 's' : ''} per month
                </div>
            )}
            {limit.type === 'weekly' && (
                <div>
                    Each client can book a max of {limit.count} appointment
                    {limit.count > 1 ? 's' : ''} per week
                </div>
            )}
            {limit.type === 'upcoming' && (
                <div>
                    Each client can book a max of {limit.count} upcoming
                    appointment{limit.count > 1 ? 's' : ''}
                </div>
            )}
            {limit.type !== 'upcoming' &&
                limit.type !== 'weekly' &&
                limit.type !== 'monthly' && (
                    <div>Unknown limit, contact support</div>
                )}
        </div>
    );
};

const LimitInput = ({ limit, setLimit }) => {
    useEffect(() => {
        if (
            limit?.type &&
            limit?.type !== 'unlimited' &&
            typeof limit?.count === 'undefined'
        ) {
            setLimit({ ...limit, count: 3 });
        }
    }, [limit?.type]);

    return (
        <div>
            <div>
                Allow each client to book{' '}
                <Select
                    options={descriptionMap}
                    value={limit?.type}
                    onChange={newValue =>
                        setLimit({ ...limit, type: newValue })
                    }
                    className="inline"
                    inputClassName="w-full sm:w-auto"
                />
                {limit?.type !== 'unlimited' && (
                    <>
                        <TextInput
                            value={limit?.count || ''}
                            label="Max Bookings"
                            type="number"
                            onChange={newValue =>
                                setLimit({ ...limit, count: newValue })
                            }
                            className="mt-4"
                            max="9999"
                            min="1"
                            inputClassName="!max-w-24"
                            autoFocus={true}
                        />
                        {limit?.count <= 0 && (
                            <InfoMessageBlock showIcon={true} className="mt-2">
                                This allows unlimited appointments, set a max of
                                1 or more to limit bookings.
                            </InfoMessageBlock>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

const LimitsClientMax = ({ limit }) => {
    return (
        <LimitsContainer
            title="Limit Bookings per Client"
            type="client"
            limit={limit}
            LimitInput={LimitInput}
            LimitDescription={LimitDescription}
        />
    );
};

export default LimitsClientMax;
